import React, { Component } from 'react';
import _sumBy from 'lodash/sumBy';
import ModalBox from '../../../shared/modal';

class GetConversionsForApprove extends Component {
	constructor(props) {
		super(props);
		this.state = { isPopupActive: false, data: '' };
		this.togglePopup = this.togglePopup.bind(this);
	}
	togglePopup() {
		this.setState(state => ({ isPopupActive: !state.isPopupActive }));
	}
	render() {
		return (
			<div>
				<Main
					{...this.props}
					togglePopup={this.togglePopup}
					isPopupActive={this.state.isPopupActive}
					data={this.state.data}
				/>
				<button
					onClick={() => this.props.getConversionsForApprove().then((data) => {
						if (data) {
							this.setState(state => ({ isPopupActive: true, data }));
						}
					})}
					type="button"
					className="ui-btn ui-btn-primary save"
				>
					{this.props.intl('Conversions for approve')}
				</button>
			</div>
		);
	}
}

const Main = props =>
	<ModalBox
		title={props.intl('Conversions for approve list:')}
		body={props.data ? PopupContent(props) : null}
		isOpen={props.isPopupActive}
		onClose={props.togglePopup}
		className="modal-overlay__content conversion-for-approve-popup"
	/>;

const PopupContent = props => {
	if (!props.data || !props.data.data || !props.data.data[0]) {
		return <div className="adv-request__wrap"></div>;
	}

	return (
		<div className="adv-request__wrap get-conversions-for-approve-form">
			<ul>
				{props.data && props.data.data && props.data.data.map((val, index) =>
					<li key={index}>
						<p>Date: {val.d} Offer name: {val.offer_name}</p>
						<p>Will be approved: {val.toApproveCount}</p>
						<p>
							{`Approve persent after: `}
							{
								val.toApproveCount
									? Math.floor(10000 * (val.toApproveCount + Number(val.approved))/Number(val.total))/100
									: 'Remains ' + Math.round(10000 * Number(val.approved)/Number(val.total)) / 100
							}%
						</p>
						<br/>
					</li>
				)}
				<li>
					<br/>
					<br/>
					<p>Will be approved total: {_sumBy(props.data.data, i => i.toApproveCount)} </p>
					<p>Average total approve persent: {
						Math.round(10000 * (
							_sumBy(props.data.data, i => i.toApproveCount + Number(i.approved))/
							_sumBy(props.data.data, i => Number(i.total))
						))/100
					}% </p>
					<p className="margin-top-30">
						<span className="total-payout-amount"> Payout: {props.data.payout} $ </span>
					</p>
				</li>
			</ul>
		</div>
	);
};

export default GetConversionsForApprove;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/conversions-approve-requests/components/forms/get-conversions-for-approve.js